/**
 * @file JobSelectionIconSlot.tsx
 *
 * @fileoverview Slot for the job selection icon.
 */
import { JobPerFileIcon } from '~/vcl/icons/JobPerFile';
import { JobPerLinkIcon } from '~/vcl/icons/JobPerLink';
import { JobPerTemplateIcon } from '~/vcl/icons/JobPerTemplate';
import JobTypeEnum from '~/jobiqo/enums/jobType';
import { Slottable } from './interfaces';

export interface JobSelectionIconSlotProps {
  /**
   * The job type.
   */
  jobType: Slottable<string>;
}

/**
 * Slot for the job selection icon.
 *
 * @param jobType
 *  The job type.
 * @returns {React.ReactNode}
 *  The job selection icon.
 */
export function getJobTypeIcon(jobType: string) {
  switch (jobType) {
    case JobTypeEnum.JOB_PER_TEMPLATE:
      return <JobPerTemplateIcon title="Job per template" />;
    case JobTypeEnum.JOB_PER_LINK:
      return <JobPerLinkIcon title="Job per link" />;
    case JobTypeEnum.JOB_PER_FILE:
      return <JobPerFileIcon title="Job per file" />;
    default:
      return null;
  }
}
